module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/5chap1#chap1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/6page13#chap2"
    }
  }, [_vm._v("Sparring with Hemingway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7chap3#chap3"
    }
  }, [_vm._v("White, Black, and Other Hopes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/8chap4#chap4"
    }
  }, [_vm._v("The Great Benny Leonard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/9chap5#chap5"
    }
  }, [_vm._v("Stillman’s Gym")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10chap6#chap6"
    }
  }, [_vm._v("Hollywood Hokum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11chap7#chap7"
    }
  }, [_vm._v("The Heavyweight Championship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/12chap8#chap8"
    }
  }, [_vm._v("Where Have You Gone, Holly Mims?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/13chap9#chap9"
    }
  }, [_vm._v("No Room for the Groom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14chap10#chap10"
    }
  }, [_vm._v("Marciano and England’s Cockell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/15chap11#chap11"
    }
  }, [_vm._v("A Champion Proves His Greatness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/16chap12#chap12"
    }
  }, [_vm._v("The Comeback: Sugar Ray Robinson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/17chap13#chap13"
    }
  }, [_vm._v("Boxing’s Dirty Business Must Be Cleaned Up Now")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/18chap14#chap14"
    }
  }, [_vm._v("The Death of Boxing?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/19chap15#chap15"
    }
  }, [_vm._v("The Chinese Boxes of Muhammad Ali")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/20chap16#chap16"
    }
  }, [_vm._v("In Defense of Boxing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/21chap17#chap17"
    }
  }, [_vm._v("Journey to Zaire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/22chap18#chap18"
    }
  }, [_vm._v("Leonard-Duran")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/23chap19#chap19"
    }
  }, [_vm._v("Ali-Holmes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/24chap20#chap20"
    }
  }, [_vm._v("The Welterweights: Sugar Ray and “Hitman” Hearns Walk with Legends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/25chap21#chap21"
    }
  }, [_vm._v("The Gerry Cooney Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/26chap22#chap22"
    }
  }, [_vm._v("The Eight-Minute War: Hagler-Hearns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/27chap23#chap23"
    }
  }, [_vm._v("Sugar’s Sweet, Marvin’s Sour")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/28chap24#chap24"
    }
  }, [_vm._v("Historic Night in the Ring: Holmes-Spinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/29chap25#chap25"
    }
  }, [_vm._v("They Fall Harder When They’re Old: Tyson-Holmes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/30chap26#chap26"
    }
  }, [_vm._v("Spinks’s Magic Act Is Not Enough")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/31chap27#chap27"
    }
  }, [_vm._v("The Second Coming of George Foreman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/32chap28#chap28"
    }
  }, [_vm._v("Foreman-Holyfield: The Bigger They Are, the Harder They Don’t Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/33chap29#chap29"
    }
  }, [_vm._v("Tyson vs. Tyson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/34chap30#chap30"
    }
  }, [_vm._v("The Mystery of the Heavyweight Mystique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/35chap31#chap31"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/36chap32#chap32"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/37chap33#chap33"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/38biography#biography"
    }
  }, [_vm._v("A Biography of Budd Schulberg")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6a7f672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-TOC.vue
// module id = 66
// module chunks = 0